import { __ } from '@wordpress/i18n';
import { SortableControl } from '../../modules/index';

const RepeaterControl = ({ attributeName, items = [], setAttributes, onClick, children }) => {
    return (
        <div className="faqmate-repeater-control">
            <div className="faqmate-repeater-new">
                <div className="faqmate-repeater-title">{__('Add Social Icon', 'faqmate-blocks')}</div>
                <button onClick={onClick}>
                    <svg viewBox="0 0 24 24" width={24} height={24} color={'#000000'} fill={'none'}>
                        <path
                            d="M12 8V16M16 12L8 12"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                        />
                    </svg>
                </button>
            </div>

            <SortableControl defaultItems={items} attributeName={attributeName} setAttributes={setAttributes}>
                {children}
            </SortableControl>
        </div>
    );
};

export default RepeaterControl;
